(ns renolit-roofing-service.shared.domain.miscellaneous
  (:require [cljc.java-time.zone-id :as jt.zone-id]
            [clojure.string :as str]
            [malli.core :as m]
            [malli.util :as mu])
  #?(:clj
     (:import [java.lang Throwable]
              [java.time Instant LocalDate LocalTime])))

(def ^:const location-srid
  "This SRID represents the WGS84 reference system.
   This is the reference system we use to store the organization location
   (longitud, latitud) in the DB, later we will reproject this location to
   whatever SRID is needed to display it."
  (int 4326))

(def ^:const default-page-size 10)

(def email-schema
  (m/schema
   [:and
    [:string]
    [:re #"^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$"]]))

(def hex-color-schema
  (m/schema
   [:and
    [:string
     {:min 7 :max 7
      :decode/string str/lower-case}]
    [:re #"^#[0-9a-f]{6}$"]]))

(def base64-schema
  (m/schema
   [:and
    [:string]
    [:or
     [:= ""]
     [:and
      [:re #"[0-9a-zA-Z+/]+={0,2}"]
      [:fn #(= 0 (rem (count %) 4))]]]]))

(def timezone-id-schema
  (m/schema
   [:and
    [:string]
    [:fn
     (fn [s]
       (try
         (some? (jt.zone-id/of s))
         #?(:clj  (catch Throwable _
                    false)
            :cljs (catch js/Error _
                    false))))]]))

(def instant-schema
  (m/-simple-schema
   {:type :hop/instant
    :pred
    (fn [x]
      (instance? #?(:clj Instant :cljs js/java.time.Instant) x))}))

(def local-date-schema
  (m/-simple-schema
   {:type :hop/local-date
    :pred
    (fn [x]
      (instance? #?(:clj LocalDate :cljs js/java.time.LocalDate) x))}))

(def local-time-schema
  (m/-simple-schema
   {:type :hop/local-time
    :pred
    (fn [x]
      (instance? #?(:clj LocalTime :cljs js/java.time.LocalTime) x))}))

(defn build-range-schema
  [value-schema]
  [:and
   [:tuple
    [:maybe
     value-schema]
    [:maybe
     value-schema]]
   [:fn
    {:error-fn (fn [_ _] :invalid-range)}
    (fn [x]
      (not-every? nil? x))]])

(defn build-pagination-schema
  [{:keys [max-page-size default-page-size]
    :or {default-page-size default-page-size
         max-page-size 150}}]
  [:map
   {:default {:page 0 :page-size default-page-size}}
   [:page
    {:default 0}
    [:int
     {:min 0}]]
   [:page-size
    {:default default-page-size}
    [:int
     {:min 1
      :max max-page-size}]]])

(defn build-sorting-schema
  [{:keys [cols default]}]
  (m/schema
   [:vector
    (if (seq default)
      {:default default}
      {})
    [:tuple
     (vec (cons :enum cols))
     [:enum :asc-nulls-first :asc-nulls-last :desc-nulls-first :desc-nulls-last]]]))

(defn build-cols-schema
  [{:keys [schema]}]
  [:vector
   (vec (cons :enum (mu/keys schema)))])

(defn- build-parameter-malli-schema-opts
  [parameter]
  (cond-> {}
    (:min parameter)
    (assoc :min (:min parameter))

    (:max parameter)
    (assoc :max (:max parameter))))

(defn build-parameter-malli-schema
  [parameter]
  #?(:clj
     (cond
       (:valid-values parameter)
       (->> (:valid-values parameter)
            (map :value)
            (into [:enum]))

       (= :text (:data-type parameter))
       [:string
        (build-parameter-malli-schema-opts parameter)]

       (= :integer (:data-type parameter))
       [:int
        (build-parameter-malli-schema-opts parameter)]

       (= :decimal (:data-type parameter))
       [:double
        (build-parameter-malli-schema-opts parameter)]

       (= :local-date (:data-type parameter))
       local-date-schema

       (= :local-time (:data-type parameter))
       local-time-schema

       :else
       [:any])

     :cljs
     (cond
       (:valid-values parameter)
       (->> (:valid-values parameter)
            (map :value)
            (into [:enum]))

       (= :text (:data-type parameter))
       [:string
        (build-parameter-malli-schema-opts parameter)]

       (= :integer (:data-type parameter))
       [:int
        (build-parameter-malli-schema-opts parameter)]

       (= :decimal (:data-type parameter))
       [:double
        (build-parameter-malli-schema-opts parameter)]

       :else
       [:any])))
